var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-t-xs-20 p-b-xs-20" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("div", { staticClass: "col-lg-12" }, [
            _c(
              "div",
              { staticClass: "button__group m-b-xs-20" },
              [
                _c(
                  "ak-button",
                  { attrs: { size: "small" }, on: { click: _vm.backToGrid } },
                  [
                    _c("i", { staticClass: "ak-icon ak-button__icon" }, [
                      _vm._v("arrow_left"),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("Ga naar lijst")) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.data !== null && _vm.data.isLocked
            ? [
                _c("div", { staticClass: "col-lg-12" }, [
                  !_vm.loading
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "ak-panel ak-panel--no-padding m-b-xs-20",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "ak-panel__header ak-panel__header--small ak-panel__header--success",
                            },
                            [
                              _c("div", { staticClass: "ak-panel__title" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("Tickets toewijzen voor ")) +
                                    " "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.data.product.title)),
                                ]),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "ak-panel__body ak-panel__body--small reading",
                            },
                            [
                              _c("p", { staticClass: "text-success" }, [
                                _c("i", { staticClass: "fa fa-check" }),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "Tickets werden reeds toegewezen. Aanpassingen zijn niet meer mogelijk."
                                      )
                                    ) +
                                    "\n                      "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "col-lg-9" },
                  [
                    !_vm.loading
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "ak-panel ak-panel--no-padding m-b-xs-20",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "ak-panel__header ak-panel__header--small ak-panel__header--success",
                              },
                              [
                                _c("div", { staticClass: "ak-panel__title" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t("Tickets toewijzen voor ")
                                      ) +
                                      " "
                                  ),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.data.product.title)),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "ak-panel__body ak-panel__body--small reading",
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _vm.data.pdfsOriginal.length
                                      ? _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "1. PDF-bestanden correct geïmporteerd. Excel-bestand kan gegenereerd worden."
                                                  )
                                                ) +
                                                "\n                                  "
                                            ),
                                          ]),
                                        ])
                                      : _c(
                                          "p",
                                          { staticClass: "text-warning" },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-warning",
                                            }),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "Gelieve eerst PDF-bestand(en) te uploaden, alvorens de Excel-bestand te genereren."
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _vm.data.pdfsOriginal.length
                                      ? _c(
                                          "ak-button",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.exportExcel($event)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "Exporteer nieuwe Excel-bestand."
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.data.pdfsOriginal.length
                                  ? _c("div", [
                                      _c("hr"),
                                      _vm._v(" "),
                                      _c("p", [
                                        _c("strong", [
                                          _vm._v(
                                            "\n                                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "2. Importeer ingevuld Excel-bestand"
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _vm.data.assigmentExcel == null
                                        ? _c("p", [
                                            _c("input", {
                                              staticClass:
                                                "ak-form__control ak-form__control--prefix form-control",
                                              attrs: {
                                                colorMode: "secondary",
                                                type: "file",
                                                accept:
                                                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                                capture: "",
                                                value: "Voeg file toe",
                                                id: "excel",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.uploadExcel()
                                                },
                                              },
                                            }),
                                          ])
                                        : _c("p", [
                                            !_vm.loading
                                              ? _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "ak-table ak-panel__table",
                                                  },
                                                  [
                                                    _c("tbody", [
                                                      _c(
                                                        "tr",
                                                        {
                                                          staticClass:
                                                            "ak-table-row",
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "ak-table-column",
                                                            },
                                                            [
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "muted",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Ingevuld Excel-bestand"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "ak-table-column",
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href:
                                                                      ":/app-kit/assign-manual-tickets/download-excel/" +
                                                                      _vm.data
                                                                        .assigmentExcel
                                                                        .id,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                              " +
                                                                      _vm._s(
                                                                        _vm.data
                                                                          .assigmentExcel
                                                                          .originalFilename
                                                                      ) +
                                                                      "\n                                          "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "ak-table-column",
                                                            },
                                                            [
                                                              _c(
                                                                "ak-button",
                                                                {
                                                                  attrs: {
                                                                    size: "small",
                                                                    colorMode:
                                                                      "error",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.deleteExcel(
                                                                          _vm
                                                                            .data
                                                                            .assigmentExcel
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "i",
                                                                    {
                                                                      staticClass:
                                                                        "ak-icon ak-button__icon",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "delete"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.data.assigmentExcel != null
                                  ? _c(
                                      "div",
                                      [
                                        _c("hr"),
                                        _vm._v(" "),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "3. Valideer Excel-bestand"
                                                  )
                                                ) +
                                                "\n                                  "
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "muted fst-italic" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("Algemene validatie")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !_vm.loading
                                          ? _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "ak-table ak-panel__table",
                                              },
                                              [
                                                _c(
                                                  "tbody",
                                                  [
                                                    _vm._l(
                                                      _vm.data.validationData
                                                        .line,
                                                      function (
                                                        validationData
                                                      ) {
                                                        return [
                                                          _vm.data.showOk
                                                            ? [
                                                                _c(
                                                                  "tr",
                                                                  {
                                                                    staticClass:
                                                                      "ak-table-row",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "ak-table-column padding-5",
                                                                        staticStyle:
                                                                          {
                                                                            padding:
                                                                              "5px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "muted",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "Lijn"
                                                                                )
                                                                              ) +
                                                                                ": " +
                                                                                _vm._s(
                                                                                  validationData.line
                                                                                )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "ak-table-column padding-5",
                                                                        staticStyle:
                                                                          {
                                                                            padding:
                                                                              "5px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                              " +
                                                                            _vm._s(
                                                                              validationData.order_code
                                                                            ) +
                                                                            "\n                                          "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "ak-table-column padding-5",
                                                                        staticStyle:
                                                                          {
                                                                            padding:
                                                                              "5px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                              " +
                                                                            _vm._s(
                                                                              validationData.user_name
                                                                            ) +
                                                                            "\n                                          "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "ak-table-column padding-5",
                                                                        staticStyle:
                                                                          {
                                                                            padding:
                                                                              "5px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                              " +
                                                                            _vm._s(
                                                                              validationData.amount
                                                                            ) +
                                                                            "\n                                          "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "ak-table-column padding-5",
                                                                        staticStyle:
                                                                          {
                                                                            padding:
                                                                              "5px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                              " +
                                                                            _vm._s(
                                                                              validationData.pdf
                                                                            ) +
                                                                            "\n                                          "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "ak-table-column padding-5",
                                                                        staticStyle:
                                                                          {
                                                                            padding:
                                                                              "5px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                              " +
                                                                            _vm._s(
                                                                              validationData.range
                                                                            ) +
                                                                            "\n                                          "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "ak-table-column padding-5",
                                                                        staticStyle:
                                                                          {
                                                                            padding:
                                                                              "5px",
                                                                          },
                                                                      },
                                                                      [
                                                                        validationData
                                                                          .errors
                                                                          .length
                                                                          ? [
                                                                              _c(
                                                                                "ul",
                                                                                _vm._l(
                                                                                  validationData.errors,
                                                                                  function (
                                                                                    data
                                                                                  ) {
                                                                                    return _c(
                                                                                      "li",
                                                                                      {
                                                                                        staticClass:
                                                                                          "ak-table-row text-danger",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                                                  " +
                                                                                            _vm._s(
                                                                                              data
                                                                                            ) +
                                                                                            "\n                                                "
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  }
                                                                                ),
                                                                                0
                                                                              ),
                                                                            ]
                                                                          : [
                                                                              _c(
                                                                                "ul",
                                                                                [
                                                                                  _c(
                                                                                    "li",
                                                                                    {
                                                                                      staticClass:
                                                                                        "text-success",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "Ok !"
                                                                                          )
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                      ],
                                                                      2
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            : _vm._e(),
                                                        ]
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "muted fst-italic" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("Algemene validatie")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          [
                                            !_vm.data.validationData.file.length
                                              ? [
                                                  _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "text-success",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("Ok !"))
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.data.validationData.file,
                                              function (error) {
                                                return [
                                                  _c(
                                                    "li",
                                                    {
                                                      staticClass:
                                                        "ak-table-row text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                      " +
                                                          _vm._s(error) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "ak-button",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.validateExcel($event)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(_vm.$t("Valideer")) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.data.isValid
                                  ? _c(
                                      "div",
                                      [
                                        _c("hr"),
                                        _vm._v(" "),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              "\n                                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "4. Tickets definitief toewijzen"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "ak-button",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.assignTickets()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                      " +
                                                _vm._s(_vm.$t("Toewijzen")) +
                                                "\n                              "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ak-loader", {
                      attrs: { size: "large", loading: _vm.loading },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-3" }, [
                  _c(
                    "div",
                    { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ak-panel__header ak-panel__header--small",
                        },
                        [
                          _c("div", { staticClass: "ak-panel__title" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t("Voeg ticket PDF-bestand(en) toe")
                                ) +
                                "\n                            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "ak-panel__body ak-panel__body--small reading",
                        },
                        [
                          !_vm.loading
                            ? _c(
                                "table",
                                { staticClass: "ak-table ak-panel__table" },
                                [
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.data.pdfsOriginal,
                                      function (pdf) {
                                        return _c(
                                          "tr",
                                          {
                                            key: pdf.id,
                                            staticClass: "ak-table-row",
                                          },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticClass: "ak-table-column",
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  { staticClass: "muted" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("Bestand")
                                                      ) + ":"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "ak-table-column",
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        ":/app-kit/assign-manual-tickets/download-pdf/" +
                                                        pdf.id,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                              " +
                                                        _vm._s(
                                                          pdf.originalFilename
                                                        ) +
                                                        "\n                                          "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "ak-table-column",
                                              },
                                              [
                                                _c(
                                                  "ak-button",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      colorMode: "error",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deletePdf(
                                                          pdf
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "i",
                                                      {
                                                        staticClass:
                                                          "ak-icon ak-button__icon",
                                                      },
                                                      [_vm._v("delete")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _c("input", {
                              staticClass:
                                "ak-form__control ak-form__control--prefix form-control",
                              attrs: {
                                colorMode: "secondary",
                                type: "file",
                                accept: "application/pdf",
                                capture: "",
                                value: "Voeg file toe",
                                id: "files",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.addPdf($event)
                                },
                              },
                            }),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }